import {
    Heading,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import React from "react";
import { useTranslation } from "react-i18next";

interface IGreetingWrapperProps {
    name: string;
    children?: React.ReactNode;
}

const GreetingWrapper = ({ name, children }: IGreetingWrapperProps) => {
    const { t } = useTranslation();

    return (
        <Stack
            alignItems="flex-start"
            justifyContent="space-between"
            flexDirection="column"
            h="100%"
            spacing={ThemeSpaceVariable.Medium}
        >
            <Heading
                as="h1"
                fontWeight="500"
                color="inherit"
                fontSize={ThemeFontSizeVariable.XLarge}
            >
                {t("hi")} {name},
            </Heading>
            {children}
        </Stack>
    );
};

export default GreetingWrapper;
